function initVariantPickerNew(context = document) {
  context.querySelectorAll('.variant-picker-new').forEach((picker) => {
    const nativeRoot =
      picker.closest('form[action*="/cart/add"]') ||
      picker.closest('section') ||
      context;

    const nativeVariantSelects = nativeRoot.querySelector(
      'variant-radios, variant-selects'
    );

    if (!nativeVariantSelects) return;

    const customerCards = picker.querySelectorAll('.vp-customer-card');
    const planCards = picker.querySelectorAll('.vp-plan-card');
    const planGroups = picker.querySelectorAll('.vp-plan-group');

    function getNativeRadio(optionIndex, value) {
      const fieldsets = nativeVariantSelects.querySelectorAll('fieldset');
      if (!fieldsets[optionIndex]) return null;

      return [...fieldsets[optionIndex].querySelectorAll('input[type=radio]')].find(
        (input) => input.value === value
      );
    }

    function clickNative(optionIndex, value) {
      const radio = getNativeRadio(optionIndex, value);
      if (!radio) return;

      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
    }

    function activateCustomer(card) {
      customerCards.forEach((c) => {
        c.classList.remove('is-active');
        c.setAttribute('aria-checked', 'false');
      });

      card.classList.add('is-active');
      card.setAttribute('aria-checked', 'true');
    }

    function activatePlan(card) {
      planCards.forEach((c) => c.classList.remove('is-active'));
      card.classList.add('is-active');
    }

    function showGroup(customer) {
      planGroups.forEach((group) => {
        group.classList.toggle(
          'is-active',
          group.dataset.customerGroup === customer
        );
      });
    }

    customerCards.forEach((card) => {
      card.addEventListener('click', () => {
        activateCustomer(card);

        const customer = card.dataset.optionValue;
        showGroup(customer);
        clickNative(0, customer);

        const firstPlan = picker.querySelector(
          `.vp-plan-group[data-customer-group="${customer}"] .vp-plan-card`
        );

        if (firstPlan) {
          activatePlan(firstPlan);
          clickNative(1, firstPlan.dataset.option2Value);
        }
      });
    });

    planCards.forEach((card) => {
      card.addEventListener('click', () => {
        activatePlan(card);
        clickNative(0, card.dataset.option1Value);
        clickNative(1, card.dataset.option2Value);
      });
    });

    nativeVariantSelects.addEventListener('change', () => {
      const checked = nativeVariantSelects.querySelectorAll(
        'input[type=radio]:checked'
      );
      if (checked.length < 2) return;

      const customer = checked[0].value;
      const duration = checked[1].value;

      customerCards.forEach((card) => {
        const active = card.dataset.optionValue === customer;
        card.classList.toggle('is-active', active);
        card.setAttribute('aria-checked', active);
      });

      showGroup(customer);

      planCards.forEach((card) => {
        card.classList.toggle(
          'is-active',
          card.dataset.option1Value === customer &&
            card.dataset.option2Value === duration
        );
      });
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initVariantPickerNew());
} else {
  initVariantPickerNew();
}

document.addEventListener('shopify:section:load', (event) => {
  initVariantPickerNew(event.target);
});

// document.addEventListener("DOMContentLoaded", () => {

//   document.querySelectorAll(".variant-picker-new").forEach((picker) => {

//     const nativeVariantSelects =
//       picker.parentElement.querySelector("variant-selects");

//     if (!nativeVariantSelects) return;

//     const customerCards = picker.querySelectorAll(".vp-customer-card");
//     const planCards = picker.querySelectorAll(".vp-plan-card");
//     const planGroups = picker.querySelectorAll(".vp-plan-group");

//     function getNativeRadio(optionIndex, value){

//       const fieldsets = nativeVariantSelects.querySelectorAll("fieldset");

//       if(!fieldsets[optionIndex]) return null;

//       return [...fieldsets[optionIndex].querySelectorAll("input[type=radio]")].find(
//         input => input.value === value
//       );

//     }

//     function clickNative(optionIndex,value){

//       const radio = getNativeRadio(optionIndex,value);

//       if(!radio) return;

//       radio.checked = true;

//       radio.dispatchEvent(new Event("change",{bubbles:true}));

//     }

//     function activateCustomer(card){

//       customerCards.forEach(c=>{

//         c.classList.remove("is-active");

//         c.setAttribute("aria-checked","false");

//       });

//       card.classList.add("is-active");

//       card.setAttribute("aria-checked","true");

//     }

//     function activatePlan(card){

//       planCards.forEach(c=>c.classList.remove("is-active"));

//       card.classList.add("is-active");

//     }

//     function showGroup(customer){

//       planGroups.forEach(group=>{

//         group.classList.toggle(
//           "is-active",
//           group.dataset.customerGroup===customer
//         );

//       });

//     }

//     customerCards.forEach(card=>{

//       card.addEventListener("click",()=>{

//         activateCustomer(card);

//         const customer = card.dataset.optionValue;

//         showGroup(customer);

//         clickNative(0,customer);

//         const firstPlan = picker.querySelector(
//           `.vp-plan-group[data-customer-group="${customer}"] .vp-plan-card`
//         );

//         if(firstPlan){

//           activatePlan(firstPlan);

//           clickNative(1,firstPlan.dataset.option2Value);

//         }

//       });

//     });

//     planCards.forEach(card=>{

//       card.addEventListener("click",()=>{

//         activatePlan(card);

//         clickNative(0,card.dataset.option1Value);

//         clickNative(1,card.dataset.option2Value);

//       });

//     });

//     nativeVariantSelects.addEventListener("change",()=>{

//       const checked = nativeVariantSelects.querySelectorAll("input[type=radio]:checked");

//       if(checked.length<2) return;

//       const customer = checked[0].value;

//       const duration = checked[1].value;

//       customerCards.forEach(card=>{

//         const active = card.dataset.optionValue===customer;

//         card.classList.toggle("is-active",active);

//         card.setAttribute("aria-checked",active);

//       });

//       showGroup(customer);

//       planCards.forEach(card=>{

//         card.classList.toggle(
//           "is-active",
//           card.dataset.option1Value===customer &&
//           card.dataset.option2Value===duration
//         );

//       });

//     });

//   });

// });